import {request} from "../request";

/**
 * 商品列表
 * @param condition
 * @returns {AxiosPromise}
 */
export function getProductListByCategory(condition) {
    return request({
        url: "/agg-portal/ap/product/search",
        params: condition
    });
}

/**
 * 商品详情
 * @param id
 * @returns {AxiosPromise}
 */
export function getProductInfo(id,language) {
    return request({
        url:"/agg-portal/ap/product/detail?id="+id+"&language="+language,
        method: 'get',
    });
}

/**
 * 添加商品到购物车
 * @param data
 */
export function addCart(data) {
    return request({
        url: "/agg-portal/ap/cart/add",
        method: 'post',
        data: data
    });
}

/**
 * 分页获取推荐商品 默认推荐（商品最新）
 * @param params
 */
export function getNewGoodsList(params) {
    return request({
        url: "/agg-portal/ap/home/recommendProductList",
        method: 'get',
        params: params
    });
}

/**
 * 获取新品推荐商品
 * @param params
 */
export function newProductList(data) {
    return request({
        url: "/agg-portal/ap/home/newProductList",
        method: 'post',
        data: data
    });
}


/**
 * 分页获取人气商品
 * @param params
 */
export function getHotProductList(data) {
    return request({
        url: "/agg-portal/ap/home/hotProductList",
        method: 'post',
        data: data
    });
}

/**
 * 获取服务说明
 */
export function certification() {
    return request({
        url: "/agg-portal/ap/order/certificationService",
        method: 'post',
    });
}


